export const bookmarkKeys = {
  list: (documentSuperId: number | string | undefined) => ['bookmarks', documentSuperId],
  withLinks: (documentSuperId: number | string | undefined) => ['bookmarksAndLinks', documentSuperId],
};
